import defaultSettings from '@/settings';
var title = window.localStorage.getItem('platSiteName') || '店铺';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}